import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sync-success',
  templateUrl: './sync-success.component.html',
  styleUrls: ['./sync-success.component.scss']
})
export class SyncSuccessComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() { }
}
